export default __webpack_public_path__ + "static/media/serveices.237c4284.png";